import type { ReactNode } from 'react';

/** Спокойная строка справочных данных; пустое значение не является ошибкой формы. */
export function ProfileFact({label,children}:{label:string;children:ReactNode}) {
  return <div className="profile-fact"><dt>{label}</dt><dd>{children || <span className="text-ink2">Не указано</span>}</dd></div>;
}
